import { Fragment, Suspense } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { adminPanelRoutes } from 'components/Admin/AdminPanelRoutes';
import { AdminPanelRoutesPaths } from 'components/Admin/types';
import { NotFoundPage } from 'common/common_components/NotFoundPage/NotFoundPage';
import { AppRoutes } from 'common/types';
import { AdminPrivateRoute } from 'common/common_components/AdminPrivateRoute';
import { AnimatedLoading } from 'common/common_components/AnimatedLoading';
import { safeReactLazy } from 'common/helpers/safe.import';
import { MainRoutes } from './config';
const AccountConfirmationPage = safeReactLazy(
  () => import('components/AccountConfirmation/AccountConfirmation'),
);

const CustomerInformation = safeReactLazy(
  () => import('components/Admin/organisms/CustomerInformation'),
);

const Admin = safeReactLazy(() => import('components/Admin/Admin'));
const ResetPassword = safeReactLazy(
  () => import('components/ResetPassword/ResetPassword'),
);

const CarEditOrAdd = safeReactLazy(
  () => import('components/Admin/organisms/CarEditOrAdd/CarEditOrAdd'),
);

const NewStaffAccount = safeReactLazy(
  () =>
    import(
      'components/Admin/organisms/Accounts/molecules/NewStaffAccount/NewStaffAccount'
    ),
);

const DiscountsEditor = safeReactLazy(
  () =>
    import(
      'components/Admin/organisms/Discounts/molecules/DiscountsEditor/DiscountsEditor'
    ),
);
const OrderInformation = safeReactLazy(
  () => import('components/Admin/organisms/OrderInformation/OrderInformation'),
);

const SubscriptionInfo = safeReactLazy(
  () => import('components/Admin/organisms/SubscriptionInfo'),
);
export const Routes = () => {
  return (
    <>
      <RouterRoutes>
        <Route
          path={AppRoutes.CONFIRM_ACCOUNT}
          element={
            <Suspense fallback={<AnimatedLoading />}>
              <AccountConfirmationPage />
            </Suspense>
          }
        />

        <Route
          path={AppRoutes.RESET_PASSWORD}
          element={
            <Suspense fallback={<AnimatedLoading />}>
              <ResetPassword />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.ADMIN}
          element={
            <Suspense fallback={<AnimatedLoading />}>
              <Admin />
            </Suspense>
          }
        >
          <Route
            path={AdminPanelRoutesPaths.SUBSCRIPTION_INFORMATION}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <SubscriptionInfo />
                </AdminPrivateRoute>
              </Suspense>
            }
          />
          <Route
            path={AdminPanelRoutesPaths.NEW_CAR}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <CarEditOrAdd />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.EDIT_CAR}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <CarEditOrAdd />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.NEW_ACCOUNT}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <NewStaffAccount />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.EDIT_ACCOUNT}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <NewStaffAccount />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.NEW_DISCOUNT}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <DiscountsEditor />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.CUSTOMER_INFORMATION}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <CustomerInformation />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          <Route
            path={AdminPanelRoutesPaths.ORDER_INFORMATION}
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <AdminPrivateRoute>
                  <OrderInformation />
                </AdminPrivateRoute>
              </Suspense>
            }
          />

          {adminPanelRoutes.map(({ path, element: Element, index }) => (
            <Fragment key={path}>
              <Route
                path={path}
                element={
                  <Suspense fallback={<AnimatedLoading />}>
                    <AdminPrivateRoute>
                      <Element />
                    </AdminPrivateRoute>
                  </Suspense>
                }
                index={index}
              />
            </Fragment>
          ))}
        </Route>

        {MainRoutes.map(({ component: Component, ...route }) => (
          <Route
            key={route.path}
            path={route.path}
            caseSensitive
            element={
              <Suspense fallback={<AnimatedLoading />}>
                <Component />
              </Suspense>
            }
          />
        ))}

        <Route path="*" element={<NotFoundPage />} />
      </RouterRoutes>
    </>
  );
};
